export const Notifications = {
  success: 'Срещата беше създадена успешно.',
  error: 'Възникна грешка при създаването на среща. Моля, опитайте отново.',
};